import { render, staticRenderFns } from "./PaidInvoice.vue?vue&type=template&id=2bac6b9e"
import script from "./PaidInvoice.vue?vue&type=script&lang=js"
export * from "./PaidInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports